module.exports = __webpack_public_path__ + "img/Fi-5mH7-62dKUjdROniYhze9Y2H6.bccf8098.png";